import { IMapControlParam } from '@/types/map'

import { loadModules } from "esri-loader";

//arcgis二维地图比例尺控件
export class ScaleBarArc2D {
    private static instances: Map<string, any>;//一个BMap.Map对应一个Control
    private view!: __esri.MapView | __esri.SceneView;
    private control: any;//缩放控件
    private visible: boolean;
    private anchor: string;//"top-left"\"top-right"\"bottom-left"\"bottom-right"
    private unit: string;//"non-metric"|"metric"|"dual"
    private style: string;//"ruler"|"line"

    constructor(view: any, option?: any) {
        this.view = view;
        this.visible = false;
        this.anchor = "top-left";
        this.style = "line";
        this.unit = "metric";
    }

    private async initiate() {
        const [ScaleBar] = await loadModules([
            "esri/widgets/ScaleBar"
        ]);
        //为地图添加一个缩放控件
        this.control = new ScaleBar({
            visible: this.visible,
            view: this.view,
        });
        this.view.ui.add(this.control, this.anchor);
    }

    public static getInstance(view: any, options?: any): ScaleBarArc2D {
        let id = view.container.id;
        if (!ScaleBarArc2D.instances) {
            ScaleBarArc2D.instances = new Map();
        }
        let instance = ScaleBarArc2D.instances.get(id);
        //若没有view对应的实例，则重新创建一个
        if (!instance) {
            instance = new ScaleBarArc2D(view, options);
            ScaleBarArc2D.instances.set(id, instance);
        }
        return instance;
    }

    public async set(params: IMapControlParam) {
        if (!this.view) {
            //地图未创建，直接返回
            return;
        }
        if (!this.control) {
            await this.initiate();
        }
        this.visible = params.visible || false;
        this._setVisible();
        this.anchor = params.anchor || "top-left";
        this._setAnchor();
        this.unit = params.options?.unit || "metric";
        this._setUnit();
        if (params.options?.scaleStyle) {
            this.style = params.options?.scaleStyle;
            this._setStyle();
        }
    }

    //设置锚点
    private async _setAnchor() {
        let ca: string;
        switch (this.anchor) {
            case "bottom-left":
                this.view.ui.move(this.control, "bottom-left");
                break;
            case "top-right":
                this.view.ui.move(this.control, "top-right");
                break;
            case "bottom-right":
                this.view.ui.move(this.control, "bottom-right");
                break;
            case "top-left":
            default:
                this.view.ui.move(this.control, "top-left");
                break;
        }
    }
    //设置是否可见
    private async _setVisible() {
        if (this.visible) {
            this.control.visible = this.visible;
        } else {
            this.control.visible = false;
        }
    }

    //设置样式
    private async _setStyle() {
        this.control.style = this.style;
    }

    //设置单位
    private async _setUnit() {
        this.control.unit = this.unit;
    }
};